import PropTypes from "prop-types"
import { chain } from "lodash"
import { Paper } from "@mui/material"
import Table from "components/material/table"
import ExcelDownload from "components/excel-download"
import columns from "./columns"

export default function TagCoverageReport({ portfolioAlias, rows, rowsPerPage, uploadDate }) {
  const fileName = `${portfolioAlias} - Tag category coverage - ${uploadDate}`

  const data = [
    ["Tag Category", "Date (YYYY-MM-DD)", "Tagged %", "Untagged equities %", "Untagged securities"],
    ...chain(rows)
      .sortBy(["tagCategory", "date"])
      .map(({ tagCategory, formattedDate, percentTagged, percentUntaggedEquities, untaggedSecurities }) => ([tagCategory, formattedDate, percentTagged, percentUntaggedEquities, untaggedSecurities]))
      .values(),
  ]

  return <Paper square elevation={1} className="tag-coverage-report">
    <Table
      title="Tag category coverage breakdown"
      idField="id"
      columns={columns}
      data={rows}
      addForm={false}
      pagination
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[]}
      actions={[<ExcelDownload key="excel-download" data={data} fileName={fileName} />]}
    />
  </Paper>
}

TagCoverageReport.propTypes = {
  portfolioAlias: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number,
  uploadDate: PropTypes.string.isRequired,
}
